import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/../Assets/resume.pdf";
import pdfPreview from "../../Assets/../Assets/resume-preview.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { Helmet } from "react-helmet-async";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <>
      <Helmet>
        <title>Resume — Cosmin Pascariu</title>
        <meta
          name="description"
          content="Experience, education and technical skills. Downloadable CV and contact details."
        />
        <link rel="canonical" href="https://cosminpascariu.comresume" />
        <meta
          name="robots"
          content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1"
        />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Cosmin Pascariu" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:title" content="Resume — Cosmin Pascariu" />
        <meta
          property="og:description"
          content="Experience, education and technical skills."
        />
        <meta property="og:url" content="https://cosminpascariu.comresume" />
        <meta
          property="og:image"
          content="https://cosminpascariu.comog/cv-1200x630.jpg"
        />
        <meta property="og:image:alt" content="Resume — Cosmin Pascariu" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Resume — Cosmin Pascariu" />
        <meta
          name="twitter:description"
          content="Experience, education and skills."
        />
        <meta
          name="twitter:image"
          content="https://cosminpascariu.comog/cv-1200x630.jpg"
        />

<script type="application/ld+json">{`
  {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    "url": "https://cosminpascariu.comresume",
    "mainEntity": { "@id": "https://cosminpascariu.com#me" },
    "about":      { "@id": "https://cosminpascariu.com#me" },
    "isPartOf":   { "@id": "https://cosminpascariu.com#website" }
  }
  `}</script>

        <script type="application/ld+json">{`
{
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://cosminpascariu.com" },
    { "@type": "ListItem", "position": 2, "name": "Resume", "item": "https://cosminpascariu.comresume" }
  ]
}
`}</script>
      </Helmet>
      <div>
        <Container fluid className="resume-section">
          <Particle />
          <Row style={{ justifyContent: "center", position: "relative" }}>
            <Button
              variant="primary"
              href={pdf}
              target="_blank"
              style={{ maxWidth: "250px" }}
            >
              <AiOutlineDownload />
              &nbsp;Download CV
            </Button>
          </Row>
          <Row className="resume">
            <Document
              file={pdfPreview}
              className="d-flex justify-content-center"
            >
              <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
            </Document>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ResumeNew;
